import { render, staticRenderFns } from "./scanOrder.vue?vue&type=template&id=a218b324&scoped=true&"
import script from "./scanOrder.vue?vue&type=script&lang=js&"
export * from "./scanOrder.vue?vue&type=script&lang=js&"
import style0 from "./scanOrder.vue?vue&type=style&index=0&id=a218b324&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a218b324",
  null
  
)

export default component.exports